<div class="viewalluser">
    <div class="text">View User</div>
    <div>
        <mat-icon class="cancel" (click)="closeDialog()" >close</mat-icon>
    </div>
</div>
<div class=" grid ">
    <div *ngFor="let c of editdata ">
        <div class="userdata ">
            <span>{{c.name.toString()}}</span>
            <span>,&nbsp;{{c.phoneNo}}
            </span>
        </div>
    </div>
</div>